import { useState } from "react";
import ClassroomManager from "./ClassroomManager";

const tabs = [
  {
    title: "Lớp học của tôi",
    icon: "fa fa-users",
    href: "#classroom",
    selected: true,
  },
  {
    title: "Thư viện",
    icon: "fa fa-bookmark",
    href: "#library",
    selected: false,
  },
  {
    title: "Soạn đề",
    icon: "fa fa-file-text-o",
    href: "#threads",
    selected: false,
  },
  {
    title: "Báo cáo",
    icon: "fa fa-bar-chart",
    href: "#report",
    selected: false,
  },
  {
    title: "Thời khoá biểu",
    icon: "fa fa-table",
    href: "#timetable",
    selected: false,
  },
  {
    title: "Inbox",
    icon: "fa fa-comments",
    href: "#inbox",
    selected: false,
  },
];
export default function TeachingManager() {
  const [nameTab, setNameTab] = useState(tabs[0].title);

  return (
    <main>
      <div className="hoc10-breadcrumb bg-gr">
        <div className="container">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#">Giáo viên</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {nameTab}
            </li>
          </ul>
        </div>
      </div>
      <div className="bg-gr">
        <div className="container">
          <ClassroomManager />
          {/* <div className="row">
            <div className="col-lg-3 col-3">
              <ul className="tab nav hoc10-tab">
                {tabs.map((tab, index) => (
                  <li key={index}>
                    <a
                      href={tab.href}
                      title={tab.title}
                      data-toggle="pill"
                      role="tab"
                      aria-selected={tab.selected}
                      className={tab.selected ? "active" : ""}
                      onClick={() => setNameTab(tab.title)}
                    >
                      <i className={`mx-auto ${tab.icon}`}></i>&ensp;
                      <span>{tab.title}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-lg-9 col-9">
              <ClassroomManager />
            </div>
          </div> */}
        </div>
      </div>
    </main>
  );
}
